import { readCachedConfig } from "../../application-config";

export const BANK_DEFAULT_COUNTRY = "US";

/**
 * Beneficiary Zip Code is optional — an empty value is accepted at any draw age.
 * A value the user does enter must be exactly this many digits.
 */
export const BANK_ZIPCODE_LENGTH = 5;

/**
 * Feature toggle for mandatory bank address (city/state), sourced from
 * application-config `draws.bankDetailsMandatoryFrom` (same API as feature
 * flags / banner).
 *
 * Empty string, missing key, or missing draws block => feature off: city/state
 * stay optional (including drafts). Any parseable value => feature on for every
 * draw; the date itself is no longer used as a cut-off (legacy transition done).
 * Keep the ISO date-only form so JS parses it as midnight UTC, matching
 * draw-service's BANK_ADDRESS_MANDATORY_FROM.
 *
 * Reads session-cached application-config on every call (never module-cached)
 * so tests and post-login refreshes see the latest value.
 */
export const getBankAddressMandatoryFromISO = (): string | null => {
  const raw = readCachedConfig()?.draws?.bankDetailsMandatoryFrom;
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  return trimmed === "" ? null : trimmed;
};

export const getBankAddressMandatoryFrom = (): Date | null => {
  const iso = getBankAddressMandatoryFromISO();
  if (!iso) return null;
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
